import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import OurServicesOverview from "./sections/OurServicesOverview";
import FamilyOwnedTrust from "./sections/FamilyOwnedTrust";
import Testimonials from "./sections/Testimonials";
import QuickContactCta from "./sections/QuickContactCta";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <OurServicesOverview />
      <FamilyOwnedTrust />
      <Testimonials />
      <QuickContactCta />
      <Footer />
    </div>;
}